// extracted by mini-css-extract-plugin
export default {"pageWrap":"Pc-z","fullWidth":"Qc-z","heading":"Rc-z","fullBleed":"Sc-z","hidden":"Tc-z"};